import { useUserTokenDecoded } from '../../redux/slices/appInfo/hooks';
import { useTRPCAPI, useTRPCQuery } from '../../trpc/trpc';

export interface UseTeamListQueryOptions {
  /** `false` skips the request, for a caller that knows it has nothing to ask yet. */
  enabled?: boolean;
}

/**
 * The shared `team.list` read behind `useMyTeamRoleStatus` and `useWorkspaceOwner`: one cache
 * entry, one stale time. A signed-out visitor (a public share page, the sign-in screen) has no
 * team, and the request would only come back UNAUTHORIZED, so it is sent only with a session.
 */
export function useTeamListQuery(options?: UseTeamListQueryOptions) {
  const trpcAPI = useTRPCAPI();
  const isSignedIn = useUserTokenDecoded() !== null;
  const enabled = isSignedIn && (options?.enabled ?? true);
  return useTRPCQuery(trpcAPI.team.list.queryOptions(undefined, { enabled, retry: false, staleTime: 5 * 60 * 1000 }));
}
